<template>
    <v-dialog
        v-model="dialogVisible"
        max-width="600"
        @input="handleDialogInput"
    >
        <v-card class="py-3 px-5">
            <v-container>
                <v-form ref="task_form" v-model="valid">
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="item.label"
                                label="Label"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="item.responsible_party == undefined || item.responsible_party != 'srg'">
                        <v-col>
                            <v-autocomplete
                                v-model="item.responsible_party"
                                :items="responsiblePartiesList"
                                label="Responsible Party"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="item.responsible_party == 'srg'">
                        <v-col>
                            <v-autocomplete
                                v-model="item.responsible_party"
                                :items="responsiblePartiesList"
                                label="Responsible Party"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                            <v-autocomplete
                                v-model="item.complexity"
                                :items="complexityList"
                                label="Complexity"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                v-model="item.owner_id"
                                :items="ownerList"
                                label="Owner"
                                :rules="[value => !!value || item.responsible_party !== 'srg' || 'Required.']"
                                :required="item.responsible_party === 'srg'"
                            />
                            <v-autocomplete
                                v-model="item.priority"
                                :items="priorityList"
                                label="Priority"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                            <v-autocomplete
                                v-model="item.task_role"
                                :items="taskRoleList"
                                label="Task Role"
                                clearable
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="item.responsible_party == undefined || item.responsible_party != 'srg'">
                        <v-col>
                            <v-autocomplete
                                v-model="item.priority"
                                :items="priorityList"
                                label="Priority"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                v-model="item.task_role"
                                :items="taskRoleList"
                                label="Task Role"
                                clearable
                            />
                        </v-col>
                    </v-row>

                    <v-row v-if="item.responsible_party == undefined || item.responsible_party == 'srg'">
                        <v-col>
                            <div class="d-flex align-center">
                                <span class="grey--text text--darken-1">External</span>
                                <v-switch
                                    class="ml-2"
                                    label="Internal"
                                    v-model="item.internal">
                                </v-switch>
                            </div>
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                v-model="item.duration"
                                :items="durationList"
                                label="Duration"
                                required
                                :rules="[value => !!value || 'Required.']"
                            />
                        </v-col>
                    </v-row>

                    <v-row v-if="this.emailTemplateArray.length">
                        <v-col colspan="2">
                            <div class="d-flex align-center">
                                <span class="grey--text text--darken-1">Set an email template for this task</span>
                                <v-switch
                                    class="ml-4"
                                    v-model="showEmailTemplate">
                                </v-switch>
                            </div>
                        </v-col>
                        
                    </v-row>
                    <v-row v-if="showEmailTemplate" class="mt-n4">
                        <v-col>
                            <v-autocomplete
                                v-model="item.email_template"
                                :items="emailTemplateArray"
                                label="Choose an email template"
                                @change="handleTemplateSelection()">
                                <!-- <template v-slot:append-item>
                                    <v-list-item @click="createNewTemplate()">Add a New Email Template</v-list-item>
                                </template> -->
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row v-if="showEmailTemplate && item.email_template">
                        <v-col>
                            <v-card 
                                flat
                                class="py-3 px-5" 
                                style="border: 1px solid #CCC">
                                <!-- <v-card-actions class="justify-end">
                                    <v-btn 
                                        x-small
                                        text
                                        class=" ma-0 py-0" 
                                        color="primary darken-1"
                                        @click="startEmailWithTemplate()">
                                        <span style="text-decoration: underline">Start a new email w/ this template</span>
                                    </v-btn>
                                </v-card-actions> -->
                                <div v-html="emailTemplateContent"></div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
            
            <v-card-actions>
                <v-btn 
                    class="mr-3" 
                    outlined 
                    color="primary darken-1"
                    @click="handleCancel"
                >
                    Cancel
                </v-btn>
                <v-btn 
                    class="white--text" 
                    color="primary darken-1"
                    @click="handleSave"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from 'axios';
    import Cookie from 'js-cookie'
    import appUrls from '../../helpers/environment';
    import { generateUUID } from '../../helpers/utilities';
    import { 
        complexityItems, 
        inactiveTaskOwnerIds,
        ownerItems,
        priorityItems,
        responsiblePartyItems,
        taskRoleItems,
        durationItems, 
        taskTypes,
    } from '../../helpers/constants'

    export default {
        name: 'ProjectStepDetails',

        components: {
            // VueEditor
        },

        props: {
            item: {
                type: Object,
                required: true,
                default: () => ({}) // Provide a default empty object
            },
            moduleData: {
                type: Object,
                default: () => ({}) // Provide a default empty object
            },
            value: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            ownerList () {
                const currentOwnerId = this.item && this.item.owner_id ? String(this.item.owner_id) : ''

                return Object.keys(ownerItems)
                    .filter(key => !inactiveTaskOwnerIds.includes(key) || key === currentOwnerId)
                    .map(key => ({
                        text: inactiveTaskOwnerIds.includes(key)
                            ? `${ownerItems[key]} (inactive)`
                            : ownerItems[key],
                        value: key
                    }))
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
        },

        watch: {
            showEmailTemplate ( newValue ) {
                if ( newValue === false ) {
                    this.item.email_template = '';
                }
            },
            value(newValue) {
                this.dialogVisible = newValue;
                if (newValue) {
                    this.initializeProps();
                }
            }
        },

        data: () => ({
            complexityList: Object.keys(complexityItems).map(key => ({ text: complexityItems[key] , value: key})),
            priorityList: Object.keys(priorityItems).map(key => ({ text: priorityItems[key] , value: key})),
            taskRoleList: Object.keys(taskRoleItems).map(key => ({ text: taskRoleItems[key] , value: key})),
            responsiblePartiesList: Object.keys(responsiblePartyItems).map(key => ({ text: responsiblePartyItems[key] , value: key})),
            taskTypesList: Object.keys(taskTypes).map(key => ({ text: taskTypes[key] , value: key})),
            durationList: Object.keys(durationItems).map(key => ({ text: durationItems[key] , value: key})),
            dialogVisible: false,
            valid: false,
            createEmailTemplate: false,
            emailTemplateSelection: '',
            emailTemplateArray: [],
            showEmailTemplate: false,
            emailTemplateContent: '',
            emailTemplateSubject: '',
        }),
    
        methods: {
            async initializeProps() {
                // console.log('mounted item',this.item)
                // console.log('mounted moduleData',this.moduleData)
                await this.getTemplateOptions()
                // Ensure props-dependent variables are initialized
                this.setShowEmailTemplate();
                // Add any other initialization logic here

                if (!this.item.name) {
                    this.$set(this.item, 'name', generateUUID());
                }
            },
            
            async getTemplateOptions() {
                try {
                    const get_template_options = await axios.get(`${appUrls.api}/api/admin/email_templates/task_template`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    });
                    const { outcome, templates } = get_template_options.data;

                    if ( outcome && templates.length > 0 ) {
                        this.emailTemplateArray = templates.map(template => ({
                            value:   template.status_id,
                            text:    template.email_name || 'Unnamed Template', // Fallback for missing names
                            subject: template.subject_text || '[No Subject]', // Fallback for missing subject
                            content: template.body_text || '[No Content]', // Fallback for missing content
                        }));
                    }
                } catch (error) {
                    console.error('Error fetching task-related email templates:', error);
                }
            },

            async setShowEmailTemplate() {
                this.showEmailTemplate = this.item.email_template != undefined && this.item.email_template != '';

                // Initialize emailTemplateContent if an email template is already set
                if (this.item.email_template) {
                    const selectedTemplate = this.emailTemplateArray.find(item => item.value === this.item.email_template);
                    this.emailTemplateContent = selectedTemplate ? selectedTemplate.content : '';
                    this.emailTemplateSubject = selectedTemplate ? selectedTemplate.subject : '';
                }
            },

            createNewTemplate: function () {
                this.createEmailTemplate = true;
                this.showEmailTemplate = false;
            },

            handleTemplateSelection: function () {
                this.createEmailTemplate = false;
                // console.log(this.emailTemplateArray);
                this.emailTemplateSelection = this.item.email_template;
                const selectedTemplate = this.emailTemplateArray.find(item => item.value === this.emailTemplateSelection);
                this.emailTemplateName = selectedTemplate ? selectedTemplate.text : '';
                this.emailTemplateSubject = selectedTemplate ? selectedTemplate.subject : '';
                this.emailTemplateContent = selectedTemplate ? selectedTemplate.content : '';
                this.showEmailTemplate = true; // Ensure the toggle remains on
            },

            handleCancel: function () {
                this.handleDialogInput(false);
            },

            handleSave: async function () {
                this.valid = this.$refs.task_form.validate();
                if (this.valid) {
                    if ( this.item.responsible_party != 'srg' ) {
                        this.item.owner_id = null;
                    }

                    this.$emit('save', this.item);
                    this.handleDialogInput(false);
                } else {
                    // Show validation errors
                    this.$refs.task_form.$el.scrollIntoView({ behavior: 'smooth' });
                }
            },
            
            handleDialogInput(value) {
                this.dialogVisible = value;
                this.$emit('input', value);

                if (!value) {
                    this.resetEmailTemplateVars();
                }
            },

            resetEmailTemplateVars() {
                // this.createEmailTemplate = false;
                this.emailTemplateSelection = '';
                this.emailTemplateArray = [];
                this.showEmailTemplate = false;
                this.emailTemplateSubject = '';
                this.emailTemplateContent = '';
                // this.item.email_template = '';
            },
         },

        created () {
            this.dialogVisible = this.value;
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/datamanagement/ProjectTaskDetails.vue